export const LAYERS = {
  SEARCH: 30,
  HEADER: 20,
  NAVIGATION: 10,
  STEP: 1,
}
